import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 12C17.5 11.1716 16.8284 10.5 16 10.5H15V13.5H16C16.8284 13.5 17.5 12.8284 17.5 12ZM5 2C5.27614 2 5.5 2.22386 5.5 2.5V5.5C5.5 5.77614 5.27614 6 5 6C4.72386 6 4.5 5.77614 4.5 5.5V2.5C4.5 2.22386 4.72386 2 5 2ZM8.5 2C8.77614 2 9 2.22386 9 2.5V5.5C9 5.77614 8.77614 6 8.5 6C8.22386 6 8 5.77614 8 5.5V2.5C8 2.22386 8.22386 2 8.5 2ZM12 2C12.2761 2 12.5 2.22386 12.5 2.5V5.5C12.5 5.77614 12.2761 6 12 6C11.7239 6 11.5 5.77614 11.5 5.5V2.5C11.5 2.22386 11.7239 2 12 2ZM18.9961 12.1543C18.9158 13.7394 17.6051 15 16 15H15V16C15 17.1046 14.1046 18 13 18H4C2.89543 18 2 17.1046 2 16V7H15V9H16L16.1543 9.00391C17.7394 9.08421 19 10.3949 19 12L18.9961 12.1543Z"
      fill="currentColor"
    />
  </svg>
);
